import React from 'react';
import GameHero from '../game/GameHero';
import Footer from '../Footer';
import * as S from './HowToPlayPage.styles';

/**
 * Reusable "How to Play" page shell.
 *
 * Composes a GameHero (fed by a `hero` config object built from i18n),
 * the page sections passed as children, and the shared Footer.
 * Each game's how-to-play page provides its own content blocks as children,
 * keeping content and presentation separated.
 */
const HowToPlayPage = ({ hero = {}, children }) => {
  return (
    <S.PageContainer>
      <GameHero
        title={hero.title}
        subtitle={hero.subtitle}
        badges={hero.badges}
        actions={hero.actions}
        image={hero.image}
        imageAlt={hero.imageAlt}
        backgroundImage={hero.backgroundImage}
        background={hero.background}
      />
      {children}
      <Footer />
    </S.PageContainer>
  );
};

export default HowToPlayPage;
